import React, {Component} from 'react';
import {Switch, Route, Redirect } from 'react-router-dom';
import {Container, Nav} from 'reactstrap';
import { connect } from 'react-redux';
import { ToastContainer } from 'react-toastify';

import Header from '../../components/Header/';
import Sidebar from '../../components/Sidebar/';
import Breadcrumb from '../../components/Breadcrumb/';
import Footer from '../../components/Footer/';

import AppLoader from './_AppLoader'
import {getData} from './actions'
import EnvConfig from '../../config/env'
import { storedb } from "../../views/client/storedb"
import {checkUrlAuthorization} from '../../lib/check-auth'
import routes from '../../routes'

class Full extends Component {
  constructor(props, context) {
    super(props, context);
  }
  componentDidMount(){
    document.title = EnvConfig.PAGE_TITLE
  }
  componentWillMount() {
    this.props.getData()
    this.unsubscribeFromHistory = this.props.history.listen(this.handleLocationChange)
    this.handleLocationChange(this.props.history.location)
  }
  handleLocationChange = (location) => {
    const dbContext = storedb()
    checkUrlAuthorization(location, dbContext, (currentPath) => {
      if (currentPath != "/dashboard") {
        this.props.history.push("/dashboard")
      }
    })
  }
  render() {
    const {
      requesting,
      tokenIsLive
    } = this.props

    if (requesting) {
      return (
        <AppLoader {...this.props}/>
      )
    }

    if (!tokenIsLive) {
      const url = encodeURIComponent(this.props.location.pathname)
      return (
        <Redirect from="/" to={`/login?callback=${url}`}/>
      )
    }


    return [
      <div key={0} className="app">
        <Header {...this.props}/>
        <div className="app-body">
          <Sidebar {...this.props}/>
          <main className="main bg-white">
            <Breadcrumb/>
            <Container fluid>
              <Switch {...this.props}>
                {routes.map((route, i) => {
                  if (route.ignore) {
                    return
                  }
                  return (
                    <Route key={i} path={route.path} component={route.component} />
                  )
                })}
                <Redirect from="/" to="/dashboard"/>
              </Switch>
            </Container>
          </main>
        </div>
        <Footer/>
      </div>,
      <ToastContainer key={1} autoClose={30000} />
    ]
  }
}

const mapStateToProps = (state) => {
  return { 
    client: state.client,
    tokenIsLive: state.global.tokenIsLive,
    requesting: state.global.requesting,
    successful: state.global.successful,
  }
}

const connected = connect(
  mapStateToProps,
  {
    getData: getData
  })(Full)

export default connected;



// WEBPACK FOOTER //
// ./src/containers/Full/Full.js